module.exports = __webpack_public_path__ + "img/door-key.52633122.svg";